import { useEffect, useState } from 'react';
import { flushAttendanceQueue, enqueueAttendance, getQueueSize } from '../services/offlineAttendanceQueue';
import { submitAttendance } from '../services/googleScriptServiceCORS';

export function useOfflineSync({ todayAttendance, showToast, setInlineStatus }) {
  const [offlineQueueCount, setOfflineQueueCount] = useState(0);

  useEffect(() => {
    setOfflineQueueCount(getQueueSize());
  }, []);

  useEffect(() => {
    const flushOnOnline = async () => {
      const result = await flushAttendanceQueue(async (payload) => submitAttendance(payload));
      if (result.sent > 0) {
        const msg = `Đã đồng bộ ${result.sent} bản ghi offline`;
        showToast(msg, 'success');
        setInlineStatus({ type: 'success', message: msg });
      }
      setOfflineQueueCount(getQueueSize());
    };

    window.addEventListener('online', flushOnOnline);
    return () => window.removeEventListener('online', flushOnOnline);
  }, [showToast, setInlineStatus]);

  useEffect(() => {
    if (!todayAttendance?.checkin_time || todayAttendance?.checkout_time) return undefined;
    if (!('Notification' in window)) return undefined;

    if (Notification.permission === 'default') {
      Notification.requestPermission().catch(() => {});
    }

    if (Notification.permission !== 'granted') return undefined;

    const now = new Date();
    const reminderTime = new Date();
    reminderTime.setHours(16, 45, 0, 0);
    const delay = reminderTime.getTime() - now.getTime();

    if (delay <= 0) return undefined;

    const timerId = window.setTimeout(() => {
      new Notification('Nhắc checkout', { body: 'Bạn đã checkin, vui lòng checkout cuối ngày.' });
    }, delay);

    return () => window.clearTimeout(timerId);
  }, [todayAttendance]);

  const enqueueOfflineIfNeeded = async ({ payload, image, error }) => {
    const isNetworkIssue = !navigator.onLine || /network|fetch|failed|timeout/i.test(String(error?.message || ''));
    if (!isNetworkIssue || !image || !payload?.latitude || !payload?.longitude) {
      return false;
    }

    await enqueueAttendance(payload, image);
    const queuedCount = getQueueSize();
    setOfflineQueueCount(queuedCount);

    const msg = `Không có mạng. Đã lưu tạm ${queuedCount} bản ghi, sẽ tự động đồng bộ khi online.`;
    setInlineStatus({ type: 'warning', message: msg });
    showToast('Đã lưu tạm chấm công offline.', 'warning');

    return true;
  };

  return {
    offlineQueueCount,
    enqueueOfflineIfNeeded,
  };
}
